<template class="bgwhite">
  <router-view></router-view>
</template>

<script>
// @ is an alias to /src
import * as firebase from "firebase";
export default {
  name: "me",
  components: {},
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    if (firebase.auth().currentUser) {
      next();
    } else {
      next("/adminLogin");
    }
  }
};
</script>

<style >
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
  margin: 10px;
}
.addBtn:hover {
  cursor: pointer;
}

.bgwhite {
  background-color: white;
}
</style>
